import React from 'react';
import { Typography, Box, Link } from '@mui/material';

export default function LinkField({ title, url, value }) {
    return (
        <Box>
            <Typography variant="subtitle2" color="textSecondary">
                {title}
            </Typography>
            <Link href={url} rel="noopener noreferrer" underline="hover">
                {value}
            </Link>
        </Box>
    );
}
